import { stripCloneSuffix } from '@/features/datasets/utils/datasetCloneNames';

/** Matches `{stem}_public` (run 1) or `{stem}_public{n}` with n >= 2. `_public1` is unused. */
const PUBLIC_SESSION_RE = /^(.+)_public(?:([2-9]|[1-9]\d+))?$/;
const PUBLIC_DATASET_TILE_MAX_CHARS = 22;

/**
 * Parse a Retrieval Agent run file name after clone-suffix strip.
 * @returns {{ stem: string, index: number, stripped: string } | null}
 */
export function parsePublicDatasetName(datasetName) {
    if (!datasetName || typeof datasetName !== 'string') return null;
    const stripped = stripCloneSuffix(datasetName) || datasetName;
    const match = stripped.match(PUBLIC_SESSION_RE);
    if (!match) return null;
    return {
        stem: match[1],
        index: match[2] ? Number(match[2]) : 1,
        stripped,
    };
}

/**
 * Keep the `_public` / `_public2` suffix visible when the tile truncates a long name.
 */
export function displayPublicDatasetName(datasetName, maxChars = PUBLIC_DATASET_TILE_MAX_CHARS) {
    const parsed = parsePublicDatasetName(datasetName);
    if (!parsed) {
        return typeof datasetName === 'string' ? datasetName : '';
    }
    if (parsed.stripped.length <= maxChars) return parsed.stripped;
    const suffix = parsed.index <= 1 ? '_public' : `_public${parsed.index}`;
    const budget = Math.max(4, maxChars - suffix.length - 1);
    return `${parsed.stem.slice(0, budget)}…${suffix}`;
}

export function isPublicDatasetName(datasetName) {
    return Boolean(parsePublicDatasetName(datasetName));
}
